import { UsersTab } from 'src/features/manage-clients/users/users-tab';

const ManageUsersTab = () => <UsersTab />;

export default ManageUsersTab;
